export const REGIONS = [
    { value: "eu-west-1", label: "EU (Europe)" },
    { value: "us-east-1", label: "NA (North America)" }
];